module.exports = __webpack_public_path__ + "img/8.469b24f1.png";